
<script>
import JmFilterEntity from './Entity'

export default {
	name: "JmFilterAsset",

	extends: JmFilterEntity
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FilterWidgets/Asset.vue